import { DropDownCell } from "./Default/DropDownCell";
import { CustomGridCellProps } from "./CustomGridCellProps";
import { GridRowClickProps } from "../GridRowClickProps";
import { ReadOnlyProps } from "../../../Project/EditProject/ReadOnlyProps";

export function FoldedUnfoldedDropdownCell({
  editable,
  isReadOnly,
  ...props
}: CustomGridCellProps & GridRowClickProps & ReadOnlyProps) {
  const localizedData = [
    { text: "F", value: "F" },
    { text: "U", value: "U" },
  ];

  return (
    <DropDownCell
      {...props}
      localizedData={localizedData}
      editable={editable ?? true}
      isReadOnly={isReadOnly}
    />
  );
}
